import { store } from 'app/redux/store';
import { IUser } from 'app/services/user';
import { updateKey } from '../edit/TaxQuestionnaire/PersonalDetails/WhereILive/CurrentAddress/slice';

export default function autoFillCurrentAddressSlice(user: IUser) {
  const { country, city, state, zipcode, address } = user;

  store.dispatch(updateKey({ key: 'country', value: country }));
  store.dispatch(updateKey({ key: 'city', value: city }));
  store.dispatch(updateKey({ key: 'state', value: state }));
  store.dispatch(updateKey({ key: 'zipcode', value: zipcode }));
  store.dispatch(updateKey({ key: 'currentMailingAddress', value: address }));
}
